import React, { useState } from 'react';
import { Leaf } from 'lucide-react';
import { useStore } from '../store';
import { INFO } from '../three/FieldGuide';

// Behavior Legend — explains each animal's ideological symbolism; highlights
// whichever species the Harpy Eagle is currently identifying.
export default function EcologyPanel({ variant = 'desktop' }) {
  const [open, setOpen] = useState(false);
  const card = useStore((s) => s.fieldCard);
  const active = card && card.name;
  return (
    <div className="pointer-events-auto relative flex flex-col items-start gap-2">
      <button
        data-testid={`ecology-toggle-${variant}`}
        onClick={() => setOpen((o) => !o)}
        className={`flex items-center gap-2 px-3 py-2 rounded-full glass text-[10px] font-bold uppercase tracking-widest transition-colors ${open ? 'text-gold border-gold' : 'text-white/80 hover:text-gold hover:border-gold'}`}
      >
        <Leaf className="w-3.5 h-3.5" /> Ecology
      </button>
      {open && (
        <div data-testid={`ecology-panel-${variant}`} className="absolute top-full right-0 mt-2 z-[85] w-72 max-h-[46vh] overflow-y-auto glass-gold rounded-xl p-3 space-y-1.5 border border-gold/30">
          <div className="font-mono text-[9px] uppercase tracking-[0.3em] text-gold/70 px-1 pb-1">Field Guide · Symbolism</div>
          {Object.values(INFO).map((s) => (
            <div key={s.name} className={`rounded-lg px-3 py-2 border transition-colors ${active === s.name ? 'border-gold/60 bg-gold/10' : 'border-white/10'}`}>
              <div className="font-serif text-sm text-white leading-tight">{s.name}</div>
              <div className="text-[11px] text-white/55 leading-snug mt-0.5">{s.text}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
